export function downloadFile(rawHref: string, name: string, defaultName = 'image'): void {
  const href = rawHref
  const aElement = document.createElement('a')

  aElement.href = href

  // The download attribute doesn't work cross-domain, but we include it for intent and future same-domain use.
  // Downloads work because Copilot::ChatAttachment serves files with Content-Disposition: attachment header.
  aElement.setAttribute('download', name || defaultName)

  document.body.appendChild(aElement) // required for Firefox
  aElement.click()
  document.body.removeChild(aElement)
}
